export function formatLastSeen(lastSeenAt: string | null): string {
  return lastSeenAt === null ? 'never' : new Date(lastSeenAt).toLocaleString();
}
